const api = {
    provinces: 'https://provinces.open-api.vn/api/?depth=3',
    job: '/api/Job/',
    industrial: '/api/Codes/Industrial',
    industrialUrgent: '/api/Codes/GetIndustrialByParam',
    option : '/api/Codes/Province',
    company : '/api/Company',
    properties : '/api/Codes/Properties',
    cv: '/api/Cv',
    user: '/api/User',
};

export default api;
